import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImplementDiagramDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 709,
	height: 815,
	viewBox: "0 0 709 815",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 608,
			y: 80,
			width: 104,
			height: 36,
			rx: 10,
			transform: "rotate(90 608 80)",
			fill: "#979083"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M605 177L590 167L575 177",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 167L590 157L574 167",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 157L590 146L574 157",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 146L590 135L574 146",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 135L590 125L574 135",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 125L590 114L574 125",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 114L590 103L574 114",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 103L590 93L574 103",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M606 93L590 82L574 93",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 120,
			y: 80,
			width: 104,
			height: 36,
			rx: 10,
			transform: "rotate(90 120 80)",
			fill: "#979083"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117 177L102 167L87 177",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 167L102 157L86 167",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 157L102 146L86 157",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 146L102 135L86 146",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 135L102 125L86 135",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 125L102 114L86 125",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 114L102 103L86 114",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 103L102 93L86 103",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118 93L102 82L86 93",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 363,
			y: 589,
			width: 104,
			height: 36,
			rx: 10,
			transform: "rotate(90 363 589)",
			fill: "#979083"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M360 686L345 676L330 686",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 676L345 666L329 676",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 666L345 655L329 666",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 655L345 644L329 655",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 644L345 634L329 644",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 634L345 623L329 634",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 623L345 612L329 623",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 612L345 602L329 612",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361 602L345 591L329 602",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.018 538.362L377.854 544.217L377.385 544.044L375.22 549.899L375.688 550.072H375.689L373.524 555.927L373.056 555.754L370.891 561.608L371.359 561.782H371.36L369.196 567.637H369.195L368.727 567.464L366.562 573.318L367.03 573.492H367.031L364.866 579.347L364.397 579.174L362.232 585.028L362.701 585.201H362.702L360.537 591.056V591.057L360.068 590.883L357.903 596.738L358.372 596.911H358.373L356.209 602.766H356.208L355.739 602.593L354.656 605.521C354.438 606.109 353.878 606.5 353.25 606.5H350.938V607H346.313V606.5H341.688V607H337.063V606.5H334.751C334.162 606.5 333.632 606.156 333.389 605.628L333.345 605.521L332.262 602.593L331.793 602.766L329.629 596.911L330.098 596.738L327.933 590.883L327.465 591.056L325.3 585.201L325.769 585.028L323.604 579.174L323.135 579.347L320.971 573.492L321.439 573.318L319.274 567.464L318.806 567.637L316.642 561.782L317.11 561.608L314.945 555.754L314.478 555.927L312.312 550.072L312.781 549.899L310.616 544.044L310.148 544.217L307.984 538.362L308.452 538.189L306.288 532.335L305.819 532.507L303.654 526.653L304.123 526.479L301.959 520.625L301.49 520.798L299.325 514.943L299.794 514.771L297.63 508.915L297.161 509.088L294.997 503.233L295.465 503.061L294.383 500.133C294.02 499.152 293.084 498.5 292.038 498.5H289.086V499H283.182V498.5H277.278V499H271.375V498.5H265.471V499H259.567V498.5H253.663V499H247.76V498.5H241.855V499H235.952V498.5H233C232.172 498.5 231.5 497.828 231.5 497V493H231V485H231.5V481C231.5 480.223 232.09 479.585 232.847 479.508L233 479.5H235.961V479H241.882V479.5H247.803V479H253.724V479.5H259.645V479H265.565V479.5H271.487V479H277.408V479.5H283.329V479H289.25V479.5H295.171V479H301.092V479.5H307.014V479H312.935V479.5H318.855V479H324.776V479.5H330.697V479H336.618V479.5H342.539V479H348.461V479.5H354.382V479H360.303V479.5H366.224V479H372.145V479.5H378.065V479H383.987V479.5H389.908V479H395.829V479.5H401.75V479H407.671V479.5H413.592V479H419.513V479.5H425.435V479H431.355V479.5H437.276V479H443.197V479.5H449.118V479H455.039V479.5H458C458.828 479.5 459.5 480.172 459.5 481V485H460V493H459.5V497C459.5 497.828 458.828 498.5 458 498.5H454.898V499H448.694V498.5H442.491V499H436.287V498.5H430.083V499H423.88V498.5H417.676V499H411.473V498.5H405.269V499H399.065V498.5H395.963C394.917 498.5 393.981 499.152 393.618 500.133L392.536 503.061L393.005 503.233L390.841 509.088L390.371 508.915L388.207 514.771L388.676 514.943H388.677L386.512 520.798L386.042 520.625L383.878 526.479L384.347 526.653L382.183 532.507L381.713 532.335L379.549 538.189L380.018 538.362ZM372.83 501.702C373.297 500.118 372.112 498.5 370.431 498.5H367.127V499H360.52V498.5H353.912V499H347.305V498.5H340.696V499H334.089V498.5H327.481V499H320.874V498.5H317.57C315.889 498.5 314.704 500.118 315.171 501.702L315.221 501.855L316.322 504.881L316.792 504.71L318.995 510.761L318.524 510.932L320.728 516.983L321.197 516.812L323.4 522.863L323.399 522.864L322.93 523.035L325.133 529.086L325.603 528.915L327.805 534.967L327.335 535.138L329.538 541.188L330.008 541.018L332.21 547.069L331.74 547.24L333.942 553.292L334.412 553.12L336.615 559.172L336.146 559.343L338.348 565.395L338.817 565.224L341.021 571.274L340.551 571.445L341.651 574.472C342.425 576.596 345.36 576.662 346.269 574.671L346.351 574.472L347.451 571.445L346.981 571.273L349.185 565.224L349.654 565.395L351.856 559.343L351.387 559.172V559.171L353.59 553.12L354.059 553.292L356.262 547.24L355.792 547.069V547.068L357.994 541.017L358.464 541.188L360.666 535.138L360.197 534.967L362.399 528.914V528.915L362.869 529.086L365.071 523.035L364.602 522.864V522.863L366.805 516.812L367.273 516.983L369.477 510.932L369.007 510.76L371.21 504.71L371.679 504.881L372.78 501.855L372.83 501.702Z",
			fill: "#A7A7A7",
			stroke: "#3D4951",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 557.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 557.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 546.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 546.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 502.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 502.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 491.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 491.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 447.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 447.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 436.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 436.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 392.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 392.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 381.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 381.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 337.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 337.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 326.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 326.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 282.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 282.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 271.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 271.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 227.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 227.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 216.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 216.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 172.833,
			y: 170,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 172.833 170)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 161.833,
			y: 150,
			width: 121,
			height: 20,
			transform: "rotate(90 161.833 150)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 558,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 558 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 547,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 547 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 503,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 503 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 492,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 492 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 448,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 448 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 437,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 437 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 393,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 393 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 382,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 382 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 338,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 338 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 327,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 327 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 283,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 283 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 272,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 272 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 228,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 228 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 217,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 217 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 173,
			y: 354,
			width: 100.952,
			height: 41,
			rx: 2,
			transform: "rotate(90 173 354)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .3,
			x: 162,
			y: 334,
			width: 116,
			height: 20,
			transform: "rotate(90 162 334)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 580,
			y: 307,
			width: 20,
			height: 469,
			transform: "rotate(90 580 307)",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M589.833 396C589.833 398.209 588.042 400 585.833 400H573.833C571.624 400 569.833 398.209 569.833 396V336.48C569.833 335.376 568.938 334.48 567.833 334.48H122.833C121.728 334.48 120.833 335.376 120.833 336.48V396C120.833 398.209 119.042 400 116.833 400H104.833C102.624 400 100.833 398.209 100.833 396V134C100.833 131.791 102.624 130 104.833 130H585.833C588.042 130 589.833 131.791 589.833 134V396ZM120.833 312.48C120.833 313.585 121.728 314.48 122.833 314.48H567.833C568.938 314.48 569.833 313.585 569.833 312.48V154C569.833 151.791 568.042 150 565.833 150H124.833C122.624 150 120.833 151.791 120.833 154V312.48Z",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M375.833 11C375.833 12.1046 374.938 13 373.833 13H355.833C354.728 13 353.833 13.8954 353.833 15V29.2834C353.833 29.6823 353.952 30.0722 354.176 30.4028L399.49 97.4927C399.714 97.8233 399.833 98.2132 399.833 98.6122V130C399.833 131.105 398.938 132 397.833 132H388.833C387.728 132 386.833 131.105 386.833 130V104C386.833 102.895 385.938 102 384.833 102H306.833C305.728 102 304.833 102.895 304.833 104V130C304.833 131.105 303.938 132 302.833 132H293.833C292.728 132 291.833 131.105 291.833 130V98.6122C291.833 98.2132 291.952 97.8233 292.176 97.4927L337.49 30.4038C337.714 30.0731 337.833 29.6833 337.833 29.2843V15C337.833 13.8954 336.938 13 335.833 13H317.833C316.728 13 315.833 12.1046 315.833 11V3C315.833 1.89543 316.728 1 317.833 1H373.833C374.938 1 375.833 1.89543 375.833 3V11ZM306.946 90.8872C306.056 92.216 307.008 94 308.608 94H383.059C384.659 94 385.611 92.216 384.721 90.8872L347.495 35.2961C346.703 34.1132 344.963 34.1132 344.171 35.2961L306.946 90.8872Z",
			fill: "#A7A7A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M685 1V206.5",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M685 253.5V455",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M651 59V1",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M651 169.5V106.5",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 662,
			y: 206,
			width: 46,
			height: 46,
			rx: 23,
			stroke: "#43FFF2",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M678.577 239.321V237.531L685.298 230.174C686.087 229.312 686.737 228.563 687.247 227.926C687.758 227.283 688.135 226.68 688.381 226.117C688.633 225.547 688.758 224.95 688.758 224.327C688.758 223.611 688.586 222.991 688.241 222.468C687.903 221.944 687.439 221.54 686.849 221.254C686.259 220.969 685.597 220.827 684.861 220.827C684.079 220.827 683.396 220.989 682.812 221.314C682.236 221.632 681.788 222.08 681.47 222.656C681.159 223.233 681.003 223.909 681.003 224.685H678.656C678.656 223.492 678.931 222.444 679.481 221.543C680.032 220.641 680.781 219.939 681.729 219.435C682.683 218.931 683.754 218.679 684.94 218.679C686.133 218.679 687.191 218.931 688.112 219.435C689.034 219.939 689.756 220.618 690.28 221.473C690.803 222.328 691.065 223.28 691.065 224.327C691.065 225.076 690.929 225.808 690.658 226.524C690.392 227.234 689.928 228.026 689.266 228.901C688.609 229.769 687.698 230.83 686.531 232.083L681.957 236.975V237.134H691.423V239.321H678.577Z",
			fill: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 628,
			y: 59,
			width: 46,
			height: 46,
			rx: 23,
			stroke: "#43FFF2",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M653.778 71.8184V92.182H651.313V74.4036H651.193L646.222 77.7047V75.199L651.313 71.8184H653.778Z",
			fill: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 83.5,
			y1: 1.5,
			x2: 83.5001,
			y2: 790.5,
			stroke: "#43FFF2",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 132.5,
			y1: 1.5,
			x2: 132.5,
			y2: 732.5,
			stroke: "#43FFF2",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 608.5,
			y1: 1.5,
			x2: 608.5,
			y2: 790.5,
			stroke: "#43FFF2",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 557.5,
			y1: 1.5,
			x2: 557.5,
			y2: 732.5,
			stroke: "#43FFF2",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M685 1L24 1",
			stroke: "#43FFF2",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M651 170L63 170",
			stroke: "#43FFF2",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M685 455L63 455",
			stroke: "#43FFF2",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M663 694H25",
			stroke: "#43FFF2",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 1V324",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 372V694",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 325,
			width: 46,
			height: 46,
			rx: 23,
			stroke: "#43FFF2",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0201 358.46C22.7076 358.46 21.5376 358.235 20.5101 357.784C19.4893 357.333 18.6773 356.707 18.074 355.905C17.4775 355.096 17.1526 354.158 17.0996 353.091H19.6053C19.6583 353.747 19.8837 354.314 20.2814 354.791C20.6792 355.262 21.1995 355.626 21.8425 355.885C22.4855 356.143 23.1981 356.273 23.9803 356.273C24.8553 356.273 25.6309 356.12 26.307 355.815C26.9831 355.51 27.5134 355.086 27.8979 354.542C28.2824 353.999 28.4746 353.369 28.4746 352.653C28.4746 351.904 28.289 351.245 27.9178 350.674C27.5466 350.098 27.003 349.647 26.2871 349.322C25.5712 348.997 24.6962 348.835 23.6621 348.835H22.0314V346.648H23.6621C24.4708 346.648 25.1801 346.502 25.79 346.21C26.4064 345.918 26.887 345.507 27.2317 344.977C27.583 344.447 27.7587 343.824 27.7587 343.108C27.7587 342.418 27.6062 341.818 27.3013 341.308C26.9964 340.798 26.5655 340.4 26.0087 340.115C25.4585 339.83 24.8089 339.687 24.0598 339.687C23.3572 339.687 22.6943 339.817 22.0712 340.075C21.4547 340.327 20.9509 340.695 20.5598 341.179C20.1687 341.656 19.9566 342.233 19.9235 342.909H17.5371C17.5769 341.842 17.8984 340.907 18.5016 340.105C19.1048 339.296 19.8936 338.666 20.8681 338.216C21.8491 337.765 22.9263 337.54 24.0996 337.54C25.3591 337.54 26.4396 337.795 27.3411 338.305C28.2426 338.809 28.9353 339.475 29.4192 340.304C29.9031 341.132 30.1451 342.027 30.1451 342.988C30.1451 344.135 29.8435 345.113 29.2402 345.922C28.6436 346.73 27.8316 347.29 26.8042 347.602V347.761C28.0901 347.973 29.0944 348.52 29.8169 349.402C30.5395 350.277 30.9007 351.361 30.9007 352.653C30.9007 353.76 30.5991 354.755 29.9959 355.636C29.3993 356.511 28.584 357.201 27.5499 357.704C26.5158 358.208 25.3392 358.46 24.0201 358.46Z",
			fill: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M558 733H367.499",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M320 733H132",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M609 791H368",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M321 791H82.9994",
			stroke: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 321,
			y: 710,
			width: 46,
			height: 46,
			rx: 23,
			stroke: "#43FFF2",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M334.642 739.006V736.977L343.591 722.818H345.063V725.96H344.068L337.307 736.659V736.818H349.358V739.006H334.642ZM344.227 743.182V722.818H346.574V743.182H344.227Z",
			fill: "#43FFF2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 321,
			y: 768,
			width: 46,
			height: 46,
			rx: 23,
			stroke: "#43FFF2",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M343.801 801.321C342.634 801.321 341.584 801.089 340.649 800.625C339.714 800.161 338.965 799.525 338.402 798.716C337.838 797.907 337.53 796.986 337.477 795.952H339.863C339.956 796.873 340.374 797.636 341.116 798.239C341.865 798.835 342.76 799.134 343.801 799.134C344.636 799.134 345.379 798.938 346.028 798.547C346.684 798.156 347.198 797.619 347.569 796.936C347.947 796.247 348.136 795.468 348.136 794.6C348.136 793.711 347.941 792.919 347.549 792.223C347.165 791.521 346.635 790.967 345.959 790.563C345.282 790.158 344.51 789.953 343.642 789.946C343.019 789.94 342.379 790.036 341.723 790.235C341.067 790.427 340.526 790.675 340.102 790.98L337.795 790.702L339.028 780.679H349.608V782.867H341.096L340.38 788.872H340.5C340.917 788.541 341.441 788.266 342.071 788.047C342.701 787.828 343.357 787.719 344.04 787.719C345.286 787.719 346.396 788.017 347.371 788.614C348.352 789.204 349.121 790.013 349.677 791.04C350.241 792.067 350.523 793.241 350.523 794.56C350.523 795.859 350.231 797.019 349.648 798.04C349.071 799.054 348.275 799.856 347.261 800.446C346.247 801.03 345.094 801.321 343.801 801.321Z",
			fill: "#43FFF2"
		})
	]
});
export default SvgImplementDiagramDark;
